import { Link } from 'react-router-dom';
import { ArrowUpRight, Check } from 'lucide-react';
import { useI18n } from '../contexts/I18nContext';
import { DIVISIONS } from '../data/divisions';
import './DivisionTiles.css';

export function DivisionTiles() {
  const { t } = useI18n();

  return (
    <section className="section" id="divisions">
      <div className="tiles-head reveal">
        <div className="section-eyebrow">{t('tiles.eyebrow')}</div>
        <h2 className="section-title">{t('tiles.title')}</h2>
        <p className="section-lead">{t('tiles.lead')}</p>
      </div>

      <div className="tiles-grid">
        {DIVISIONS.map((d, i) => {
          const Icon = d.icon;
          return (
            <Link
              to={d.path}
              key={d.key}
              className={`tile ${d.accent} reveal`}
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <span className="tile-glow" aria-hidden="true" />
              <div className="tile-top">
                <span className="tile-icon">
                  <Icon size={24} />
                </span>
                <span className="tile-badge">{t(d.badgeKey)}</span>
              </div>

              <h3 className="tile-name">{t(d.nameKey)}</h3>
              <p className="tile-tagline">{t(d.taglineKey)}</p>

              <ul className="tile-features">
                {d.featureKeys.map((fk) => (
                  <li key={fk}>
                    <Check size={15} />
                    <span>{t(fk)}</span>
                  </li>
                ))}
              </ul>

              <span className="tile-cta">
                {t('common.explore')}
                <ArrowUpRight size={17} />
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
